"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = exports.RelativeRecurringDateSetupSchema = exports.StaticRecurringDateSetupSchema = exports.RecurringDateSetupConfigsSchema = exports.SetupTypeSchema = exports.SetupTypeIterable = void 0;
const _imports_1 = require("./_imports");
exports.SetupTypeIterable = ['static', 'relative'];
exports.SetupTypeSchema = _imports_1.z.enum(exports.SetupTypeIterable);
exports.RecurringDateSetupConfigsSchema = _imports_1.z.union([
    _imports_1.RecurringDate.ConfigSchema,
    _imports_1.RecurringDate.RelativeConfigSchema,
]);
// Compile-time assertion helper
exports.StaticRecurringDateSetupSchema = _imports_1.z.object({
    type: _imports_1.z.literal('static'),
    config: _imports_1.RecurringDate.ConfigSchema,
});
exports.RelativeRecurringDateSetupSchema = _imports_1.z.object({
    type: _imports_1.z.literal('relative'),
    config: _imports_1.RecurringDate.RelativeConfigSchema,
    triggerDateFormula: _imports_1.z.string(),
});
exports.ConfigSchema = _imports_1.z.object({
    /**
     * This will represent the base "name" of the output variable.
     * Also will be attribute for other areas (Athena Queries) to reference
     */
    field: _imports_1.z.string(),
    setup: _imports_1.z.union([
        exports.StaticRecurringDateSetupSchema,
        exports.RelativeRecurringDateSetupSchema,
    ]),
    // Since we're allowing other areas to also utilize these fields, like
    // output template, and not just Athena queries, we'd ultimately want to
    // manage fallback (default) behavior here as well. That way, we can
    // pre-populate variables here based on "maxCount" so other references
    // would still be valid at time of generation
    maxCount: _imports_1.z.number(),
    defaultTo: _imports_1.z.object({
        value: _imports_1.z.string(),
        parseString: _imports_1.z.boolean(),
    }),
});
//# sourceMappingURL=GlobalRecurringDate.js.map